var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('tr', {
    key: _vm.domain.DomainId,
    staticClass: "font-weight-bold",
    class: `table-${_vm.designation.bgColor}`
  }, [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v(" " + _vm._s(_vm.domain.Name) + " ")]), _c('td', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fas fa-info-circle text-muted",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "right",
      "data-html": "true",
      "data-title": _vm.domain.Description,
      "original-title": _vm.domain.Description
    }
  })]), _c('td'), _c('td'), _c('td', {
    staticClass: "text-nowrap text-right"
  }, [_vm._v(_vm._s(_vm._f("numFormat")(_vm.pointsEarned, "0.00")) + " out of " + _vm._s(_vm.pointsPossible))]), _c('td', {
    staticClass: "text-right"
  }, [_vm._v(" " + _vm._s(_vm._f("asRoundedPercentage")(_vm.pointsEarned > 0 && _vm.pointsPossible ? _vm.pointsEarned / _vm.pointsPossible : 0)) + " ")]), _c('td', {
    staticClass: "text-center"
  }, [_c('span', {
    staticClass: "badge p-2 elevate",
    class: `badge-${_vm.designation.bgColor}`
  }, [_vm._v(_vm._s(_vm.designation.label))])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };